/**
 * Created by andrey on 01.02.2021.
 */

const UnitsTab = cc.Node.extend({
    ctor: function (codes, options) {
        this.codes = codes;
        const families = this.families = this.createFamilies(codes, options);

        const styles = cleverapps.styles.UnitsTab;

        let children = families;
        if (styles.separator) {
            children = families
                .map((family, index) => {
                    let separator;
                    if (index > 0) {
                        separator = cleverapps.UI.createScale9Sprite(bundles.merge.frames.families_separator_png, cleverapps.UI.Scale9Rect.TwoPixelXY);
                        separator.setContentSize(styles.separator.width, separator.height);
                        separator.setLocalZOrder(1);
                    }
                    family.setLocalZOrder(2);
                    return [separator, family].filter(Boolean);
                })
                .flat();
        }

        const content = this.content = new cleverapps.Layout(children, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin,
            padding: styles.padding
        });

        const scroll = this.scroll = new cleverapps.UI.ScrollView(content, {
            scrollBarEnabled: false,
            direction: cleverapps.UI.ScrollView.DIR_VERTICAL
        });

        scroll.setContentSize(content.width, Math.min(content.height, options.height));
        scroll.scrollToDefault();
        scroll.setAlignment({
            x: { align: "center" },
            y: { align: "top" }
        });

        this._super();
        this.setContentSize2(options);
        this.setAnchorPoint(0.5, 0.5);
        this.setAlignment({
            x: { align: "center" },
            y: { align: "center" }
        });
        this.addChild(scroll);
        cleverapps.eventBus.on("unitStatusChanged", this.onUnitStatusChanged.bind(this), this);
    },

    createFamilies: function (codes, options) {
        return codes.map((code) => {
            const units = cleverapps.unitsLibrary.listOpenedPlusOneWithUnknown(code);
            if (!units.length) {
                return;
            }

            const icons = units.map((unit) => new UnitLibraryIcon(unit));

            return new FamilyLayout(code, icons, {
                width: options.width,
                resolutionMode: options.resolutionMode
            });
        }, this).filter(Boolean);
    },

    onUnitStatusChanged: function (unit) {
        if (!this.codes.includes(unit.code)) {
            return;
        }

        this.stopAllActions();
        this.runAction(new cc.Sequence(
            new cc.DelayTime(1.0),
            new cc.CallFunc(this.scrollToFresh.bind(this))
        ));
    },

    onSelectTab: function (params) {
        this.scroll.scrollToDefault();
        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.3),
            new cc.CallFunc(this.scrollToFresh.bind(this, params))
        ));
    },

    onClickTab: function () {
        this.scrollToFresh();
    },

    scrollToFresh: function (params) {
        this.stopAllActions();

        params = params || {};
        const icon = this.findFamilyIcon((unit) => params.searchUnit && Unit.IsApplicable(params.searchUnit, unit)) || this.findFamilyIcon((unit) => cleverapps.unitsLibrary.isFresh(unit));

        if (icon) {
            this.scroll.runAction(new cc.ScrollAction(icon, {
                duration: 0.8,
                visibleBox: {
                    top: 0.85,
                    bottom: 0.1
                }
            }).easing(cc.easeBackInOut()));
        }
    },

    onUnSelectTab: function () {
        this.scroll.stopAutoScroll();
    },

    findFamilyIcon: function (filter) {
        for (let i = 0; i < this.families.length; ++i) {
            const family = this.families[i];

            for (let j = 0; j < family.icons.length; ++j) {
                const icon = family.icons[j];

                if (filter(icon.unit)) {
                    return icon;
                }
            }
        }
    }
});

cleverapps.styles.UnitsTab = {
    margin: 60,
    padding: {
        x: 0,
        y: 55
    }
};